import React, { useCallback, useContext, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../Authentication/AuthContext';
import {
  getBookList,
  getBookNameByLanguage,
  getTableHeadersByLanguage,
  getTestamentConfig,
  normalizeBookKey,
} from './BookNames';
import {
  prefetchWholeBookInBackground,
  startBibleDownloadCache,
} from './DownloadCache';
import './Testaments.css';

function Testaments({ testamentType = 'old' }) {
  const navigate = useNavigate();
  const { language } = useContext(AuthContext); 

  const config = getTestamentConfig(testamentType);

  const books = useMemo(() => {
    return getBookList(testamentType);
  }, [testamentType]);

  const { number, books: booksHeader } = getTableHeadersByLanguage(language);

  useEffect(() => {
    startBibleDownloadCache();
  }, []);

  const prefetchBook = useCallback(
    (bookName) => {
      const bookKey = normalizeBookKey(bookName);

      prefetchWholeBookInBackground(testamentType, bookKey);
    },
    [testamentType]
  );

  const handleBookClick = (bookName) => {
    const bookKey = normalizeBookKey(bookName);

    prefetchBook(bookKey);

    navigate(`/${config.routeSegment}/chapters/${bookKey}`);
  };

  const handleBookHover = (bookName) => {
    prefetchBook(bookName);
  };

  return (
    <div className="testament-list-page">
      <h2 className="testament-heading">
        {getBookNameByLanguage(config.titleKey, language)}
      </h2>

      <table className="testament-table">
        <thead>
          <tr>
            <th className="testament-header-cell testament-index-column">
              {number}
            </th>
            <th className="testament-header-cell testament-book-name-column">
              {booksHeader}
            </th>
          </tr>
        </thead>

        <tbody>
          {books.map((bookName, index) => (
            <tr
              key={bookName}
              onClick={() => handleBookClick(bookName)}
              onMouseEnter={() => handleBookHover(bookName)}
              onFocus={() => handleBookHover(bookName)}
              className="testament-book-row"
            >
              <td className="testament-index-column">{index + 1}</td>
              <td className="testament-book-name-column">
                {getBookNameByLanguage(bookName, language)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Testaments;